// Versión de la aplicación basada en el hash del commit
// En desarrollo usa valores por defecto, en build usa __APP_VERSION__ inyectado por Vite
declare global {
  const __APP_VERSION__: {
    hash: string;
    buildTime: string;
    version: string;
  } | undefined;
}

export const APP_VERSION = (typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : {
  hash: '7abce46',
  buildTime: new Date().toISOString(),
  version: '1.0.0'
});

// Función para obtener la versión como string
export const getAppVersion = (): string => {
  return `${APP_VERSION.version}-${APP_VERSION.hash}`;
};

// Función para mostrar información de versión en consola
export const logAppVersion = (): void => {
  console.log(
    `%c🚀 BIM Catastro v${getAppVersion()}`,
    'color: #4CAF50; font-weight: bold; font-size: 14px;'
  );
  console.log(
    `%c📅 Build: ${new Date(APP_VERSION.buildTime).toLocaleString()}`,
    'color: #2196F3; font-size: 12px;'
  );
  console.log(
    `%c🔗 Commit: ${APP_VERSION.hash}`,
    'color: #FF9800; font-size: 12px;'
  );
};
